import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="rounded-3 shadow mx-lg-5 mx-md-3 mx-sm-1 my-4 p-xxl-5 py-3 text-center main-color text-white">
      <div class="row row-cols-1 row-cols-md-3 mx-lg-5 mx-md-3 mx-sm-1 text-start">
        <div class="col mb-3">
          <h5>Quick links</h5>
          <ul class="nav flex-column">
            <li class="nav-item mb-2">
              <Link to="#" class="nav-link p-0 text-white">
                Terms & Privacy
              </Link>
            </li>
            <li class="nav-item mb-2">
              <Link to="#" class="nav-link p-0 text-white">
                Carrot's Pricing
              </Link>
            </li>
          </ul>
        </div>

        <div class="col mb-3">
          <h5>Quick links</h5>
          <ul class="nav flex-column">
            <li class="nav-item mb-2">
              <Link to="#" class="nav-link p-0 text-white">
                FAQs
              </Link>
            </li>
            <li class="nav-item mb-2">
              <Link to="#" class="nav-link p-0 text-white">
                Get In Touch
              </Link>
            </li>
          </ul>
        </div>

        <div class="col mb-3">
          <h5>Follow Us</h5>
          <ul class="nav flex-column">
            <li class="nav-item mb-2">
              <Link to="#" class="nav-link p-0 text-white">
                Facebook
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Footer;
